import { Widget } from './../models/widget';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { Injectable } from "@angular/core";
import { DashboardItem } from '@dashboards/models/dashboard-item';
import { UserSettingsService } from '@user-settings/services/user-settings.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';

@Injectable({ providedIn: 'root' })
export class MasterAdminDashboardItemProviderService {

  constructor(private readonly userSettingsService: UserSettingsService) {
  }

  getDashboardItems(source: string) {

    return this.userSettingsService.getUserSettings().pipe(map(us => {

      const result: Widget[] = [];
      const productEnabled = (addOnCode: string) => us.EnabledAddOns.includes(addOnCode);

      const create = (dashboardName: string, title: string, widgetName: string, enabled = true) => {
        const item = new DashboardItem();
        item.title = title;
        item.rows = 3;
        item.cols = 5;
        item.widgetName = widgetName;
        item.dashboardName = dashboardName;
        item.resizeEnabled = false;
        item.dragEnabled = false;
        item.disabled = !enabled;
        return item;
      }
      result.push(create(source, 'Mojo Admin', 'MojoAdmin'));
      result.push(create(source, 'Mci Admin', 'MciAdmin', productEnabled(MojoWellKnownNames.AddOnCodes.WS004_Mci)));
      result.push(create(source, 'Ids Admin', 'IdsAdmin'));
      result.push(create(source, 'Mfs Admin', 'MfsAdmin', productEnabled(MojoWellKnownNames.AddOnCodes.WS005_Mfs)));
      result.push(create(source, 'Mft Admin', 'MftAdmin', productEnabled(MojoWellKnownNames.AddOnCodes.WS006_Mft)));
      return result;

    }));
  }


}
